import React from 'react';
import Footer from '../Footer';
import './PolitikaPrivatnosti.css';

const PRIVACY_DATA = {
  title: "Politika privatnosti",
  lastUpdated: "Posljednje ažuriranje: 25.6.2026.",
  sections: [
    {
      id: "info",
      content: [
        "Ova web stranica isključivo prikazuje informativni sadržaj (usluge, tim, galeriju, lokaciju i kontakt podatke).",
        "Ne prikupljamo, ne obrađujemo niti pohranjujemo nikakve osobne podatke putem ove stranice.",
        "Stranica ne koristi kolačiće (cookies), nema kontakt forme, nema analitiku niti bilo kakve alate za praćenje posjetitelja.",
        "Ako nas kontaktirate izravno putem e-maila ili telefona (izvan ove stranice), tada podatke koje nam dobrovoljno dostavite čuvamo isključivo u svrhu komunikacije."
      ]
    },
    {
      id: "contact",
      title: "Kontakt",
      content: [
        "Dr. Pezo - specijalistička veterinarska praksa za male životinje",
        "Adresa: Ulica Ede Murtića 2, 10000 Zagreb, Hrvatska",
        "Email: amb.pezo@gmail.com",
        "Telefon: +385 1 655 1331"
      ]
    }
  ]
};

function PolitikaPrivatnosti() {
  return (
    <>
      <main className="privacy-container">
        <div className="privacy-wrapper">
          <article className="privacy-card">
            <header className="privacy-header">
              <h1 className="privacy-title">{PRIVACY_DATA.title}</h1>
              <p className="last-updated">{PRIVACY_DATA.lastUpdated}</p>
            </header>

            {PRIVACY_DATA.sections.map((section) => (
              <section key={section.id} className="privacy-section">
                {section.title && <h2>{section.title}</h2>}
                {section.content.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </section>
            ))}
          </article>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default PolitikaPrivatnosti;